import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import MagnifyingGlassSVG from './magnifying-glass.svg';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBarWrapper = styled.div(({ theme }) => {
  return `
    display: flex;
    align-items: center;
    width: 100%;
    background: ${theme.new.color.neutral[1]};
    border: 1px solid ${theme.new.color.neutral[5]};
    border-radius: 12px;
    padding: 12px 18px;
    box-shadow: 0px 2px 3px ${theme.new.color.neutral[5]};
    margin-bottom: 10px;
  `;
});

const SearchIcon = styled.img`
  margin-right: 8px;
`;

const SearchInput = styled.input(({ theme }) => {
  return `
    flex: 1;
    border: none;
    outline: none;
    font-size: ${theme.new.type.size[16]};
`;
});

const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: 8px;
`;

const ClearIcon = styled.span(({ theme }) => {
  return `
font-size: ${theme.new.type.size[16]};
`;
});

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      onSearch(query);
    }, 500); // Set the delay in milliseconds (e.g., 500ms)

    return () => {
      clearTimeout(delaySearch);
    };
  }, [query, onSearch]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const clearSearch = () => {
    setQuery('');
  };

  return (
    <SearchBarWrapper>
      <SearchIcon src={MagnifyingGlassSVG}></SearchIcon>
      <SearchInput type="text" placeholder="Search for a resident" value={query} onChange={handleSearch} />
      {query !== '' && (
        <ClearButton onClick={clearSearch}>
          <ClearIcon>✕</ClearIcon>
        </ClearButton>
      )}
    </SearchBarWrapper>
  );
};

export default SearchBar;
